@if(!isNarrowTemplate()) {
    <div class="wrapper ribbon">
      <div class="creative-content" (click)="onClick()" (keydown)="onClick()">
      <img
      [src]="templateData()?.MAIN_IMG || ''"
      [alt]="templateData()?.MAIN_IMG_ALT || ''"
      class="image"
      [attr.aria-label]="templateData()?.MAIN_IMG_ALT || ''"
    />
      <div class="cta-container">
          <button
            class="cta-button"
            type="button"
          >
            {{ templateData()?.CTA_TEXT || '' }}
          </button>
            <svg 
              display="none" 
              viewBox="0 0 18 18" 
              xmlns="http://www.w3.org/2000/svg"
              [class.external-link]="templateData()?.CTA_TAB_BEHAVIOR === '_blank'">
                <path d="M2 2V16H16V9H18V16C18 17.1 17.1 18 16 18H2C0.89 18 0 17.1 0 16V2C0 0.9 0.89 0 2 0H9V2H2ZM11 2V0H18V7H16V3.41L6.17 13.24L4.76 11.83L14.59 2H11Z"/>
            </svg>
          </div>
      <h2 class="headline" [style.color]="templateData()?.HEADLINE_COLOR ? '#' + templateData()?.HEADLINE_COLOR : null">{{ templateData()?.HEADLINE || '' }}</h2>
   </div>  
  </div>
} @else {
    <div class="wrapper narrow" (click)="onClick()" (keydown)="onClick()">
    <img
      [src]="templateData()?.MAIN_IMG || ''"
      [alt]="templateData()?.MAIN_IMG_ALT || ''"
      class="image"
    />
    <div class="content" [style.background-color]="templateData()?.BG_COLOR ? '#' + templateData()?.BG_COLOR : null">
      <h2 class="headline" [style.color]="templateData()?.HEADLINE_COLOR ? '#' + templateData()?.HEADLINE_COLOR : null">{{ templateData()?.HEADLINE || '' }}</h2>
    </div>
  </div>
}